import type { SVGProps } from 'react';
import { forwardRef, Ref } from 'react';

const SvgVerkeerdGebruik = (
  props: SVGProps<SVGSVGElement>,
  ref: Ref<SVGSVGElement>,
) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    fill="none"
    viewBox="0 0 40 40"
    role="img"
    aria-hidden={true}
    ref={ref}
    {...props}
  >
    <path
      fill="#F8BADD"
      fillRule="evenodd"
      d="m9.06 14.74 7.96-5.04L12.95 7 4 13v15h5.06z"
      clipRule="evenodd"
    />
    <path
      fill="#F170B8"
      fillRule="evenodd"
      d="M10.06 15.29 20 9l10.06 6.29V31h-20z"
      clipRule="evenodd"
    />
    <path
      fill="#F8BADD"
      d="m30.56 33.44-3.98-3.99c2.09-3.08 1.81-7.29-.86-10.05-2.99-3.09-8.09-3.21-11.21-.25-3.28 3.11-3.33 8.29-.16 11.47a7.96 7.96 0 0 0 10.12.96l3.98 3.99c.58.59 1.53.59 2.12 0 .58-.59.58-1.53 0-2.12zM15.75 29.2a6 6 0 0 1 0-8.48c2.34-2.34 6.13-2.34 8.46 0a6 6 0 0 1 0 8.48c-2.34 2.34-6.13 2.34-8.46 0"
    />
    <path
      fill="#F8BADD"
      fillRule="evenodd"
      d="m26.95 7-3.99 2.67 8.1 5.06V28H36V13z"
      clipRule="evenodd"
    />
    <path
      stroke="#00215B"
      strokeMiterlimit={10}
      d="M8.06 18.28 18 12"
    />
    <path
      stroke="#00215B"
      strokeMiterlimit={10}
      strokeWidth={0.84}
      d="M20.05 29.61c-2.57 0-4.65-2.08-4.65-4.65"
    />
  </svg>
);

/* eslint-disable import/no-default-export */
const ForwardRef = forwardRef(SvgVerkeerdGebruik);

export default ForwardRef;
